import { Component, OnInit } from '@angular/core';
import { extend } from 'chartist';
import { Role } from 'src/app/core/models/role.enum';

@Component({
  selector: 'app-base-list',
  templateUrl: './base-list.component.html',
  styleUrls: ['./base-list.component.scss']
})
export class BaseListComponent implements OnInit {
  Role = Role;
  Loading: boolean = true;
  constructor() { }

  public itemPerPage = parseInt(localStorage.getItem('itemPerPage')) || 10
  public pageIndex = 1
  private listDebounceTimer: ReturnType<typeof setTimeout> | null = null;

  ngOnInit(): void {
  }

  /**
   * Arama kutusu gibi her tuşta değişen süzgeçler için: son çağrıdan `ms` sonra `fn`
   * bir kez çalışır (e-fatura listesindeki 400 ms gecikmeyle aynı).
   */
  debounceList(fn: () => void, ms: number = 400): void {
    if (this.listDebounceTimer) clearTimeout(this.listDebounceTimer);
    this.listDebounceTimer = setTimeout(() => {
      this.listDebounceTimer = null;
      fn();
    }, ms);
  }

}
